<sw-page class="topdata-contact-login-list">
    <template #search-bar>
        <sw-search-bar
            initial-search-type="tdcl_customer_contact"
            :initial-search="term"
            @search="onSearch"
        />
    </template>

    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.contactList.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onOpenConvertModal">
            {{ $tc('TopdataContactLoginSW6.admin.convertCustomerBtn') }}
        </sw-button>

        <sw-button variant="primary" @click="getList">
            {{ $tc('global.default.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            identifier="tdcl_customer_contact"
            @page-change="onPageChange"
        >
            <template #column-firstName="{ item }">
                <a
                    class="topdata-contact-login-list__contact-link"
                    @click.prevent="openContact(item)"
                >
                    {{ getContactName(item) }}
                </a>
            </template>

            <template #column-customer="{ item }">
                <a
                    v-if="item.customer"
                    class="topdata-contact-login-list__customer-link"
                    @click.prevent="openCustomer(item.customerId)"
                >
                    {{ getCustomerLabel(item) }}
                </a>
                <span v-else>—</span>
            </template>

            <template #column-active="{ item }">
                <sw-badge :variant="item.active ? 'success' : 'danger'">
                    {{ item.active
                        ? $tc('TopdataContactLoginSW6.contactList.list.status.active')
                        : $tc('TopdataContactLoginSW6.contactList.list.status.inactive') }}
                </sw-badge>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="openContact(item)">
                    {{ $tc('TopdataContactLoginSW6.contactList.list.action.open') }}
                </sw-context-menu-item>
                <sw-context-menu-item @click="onEditContact(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onDeleteContact(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-modal
            v-if="showContactModal"
            :title="$tc('TopdataContactLoginSW6.admin.editContact')"
            variant="default"
            @modal-close="onCloseModal"
        >
            <sw-container columns="1fr 1fr" gap="16px">
                <sw-field
                    v-model="currentContact.email"
                    type="text"
                    :label="$tc('TopdataContactLoginSW6.admin.email')"
                    :error="contactEmailError"
                    validation="required"
                />

                <sw-field
                    v-model="currentContact.password"
                    type="password"
                    :label="$tc('TopdataContactLoginSW6.admin.password')"
                    :helpText="currentContact.id ? $tc('TopdataContactLoginSW6.admin.passwordHelp') : ''"
                    :validation="currentContact.id ? undefined : 'required'"
                />
            </sw-container>

            <sw-field
                v-model="currentContact.salutationId"
                type="select"
                :label="$tc('sw-customer.baseForm.labelSalutation')"
                validation="required"
            >
                <option value="">{{ $tc('TopdataContactLoginSW6.admin.noAddress') }}</option>
                <option v-for="salutation in salutations" :key="salutation.id" :value="salutation.id">
                    {{ salutation.translated.displayName }}
                </option>
            </sw-field>

            <sw-container columns="1fr 1fr" gap="16px">
                <sw-field
                    v-model="currentContact.firstName"
                    type="text"
                    :label="$tc('TopdataContactLoginSW6.admin.firstName')"
                    validation="required"
                />

                <sw-field
                    v-model="currentContact.lastName"
                    type="text"
                    :label="$tc('TopdataContactLoginSW6.admin.lastName')"
                    validation="required"
                />
            </sw-container>

            <sw-field
                v-if="currentContact.id"
                v-model="currentContact.active"
                type="switch"
                :label="$tc('TopdataContactLoginSW6.admin.active')"
            />

            <template #modal-footer>
                <sw-button @click="onCloseModal" size="small">
                    {{ $tc('global.default.cancel') }}
                </sw-button>
                <sw-button variant="primary" @click="onSaveContact" size="small">
                    {{ $tc('global.default.save') }}
                </sw-button>
            </template>
        </sw-modal>

        <sw-delete-modal
            ref="contactDeleteModal"
            :title="$tc('TopdataContactLoginSW6.admin.deleteContactTitle')"
            :text="$tc('TopdataContactLoginSW6.admin.deleteContactText')"
            @confirm="onConfirmDeleteContact"
        />

        <topdata-convert-customer-modal
            v-if="showConvertModal"
            @modal-close="onCloseConvertModal"
            @conversion-success="onConversionSuccess"
            @conversion-error="onConversionError"
        />
    </template>
</sw-page>